<template>
    <div class="el-table-container templateBox">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1)">
            <el-form-item prop="basicDataName" label="元数据模板名称：" v-show="navigation.length == 1">
                <el-input v-model.trim="searchForm.basicDataName" maxlength="50" placeholder="请输入元数据模板名称"
                          clearable></el-input>
            </el-form-item>
            <el-form-item prop="basicName" label="元数据名称：" v-show="navigation.length == 1">
                <el-input v-model.trim="searchForm.basicName" maxlength="50" placeholder="请输入元数据名称/别名"
                          clearable></el-input>
            </el-form-item>
            <el-form-item prop="basicRename" label="元数据名称：" v-show="navigation.length > 1">
                <el-input v-model.trim="searchForm.basicRename" maxlength="50" placeholder="请输入元数据名称/别名"
                          clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
            <el-dropdown class="f_r">
                <el-button type="primary" size="small">{{showList == 0 ? '卡片':'列表'}}<i
                        class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-show="showList == 1" @click.native="showList = 0">卡片</el-dropdown-item>
                    <el-dropdown-item v-show="showList == 0" @click.native="showList = 1">列表</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </el-form>
        <div class="flex_l_c navigationBox">
            <img src="@/assets/img/templateIcon.png" class="templateIcon">
            <div v-for="(item, index) in navigation" :key="index" @click="selNavigation(item, index)">
                <el-link v-if="index == navigation.length-1" type="primary">{{item.basicDataName || item.basicRename}}</el-link>
                <el-link v-else>{{item.basicDataName || item.basicRename}}</el-link>
                <span class="arrows" v-if="index < navigation.length-1">></span>
            </div>
        </div>
        <!--模板-->
        <div class="dataBox" v-if="navigation.length == 1" v-loading="loading">
            <el-row class="cardBox" :gutter="10" v-show="showList == 0">
                <el-col class="m_b1 pointer" :span="6" v-for="(item, index) in dataList" :key="index">
                    <div class="el-card is-always-shadow templateCard" @click="searchTemplateData(item, 0)">
                        <div class="flex_b_c p_all1">
                            <div class="omit flex_1 name"><img src="@/assets/img/templateIcon.png" class="templateIcon">{{item.basicDataName}}</div>
                        </div>
                        <div class="info">
                            <div class="omit">可修改权限 {{item.basicDataAuthorityStrings || '全馆'}}</div>
                            <div>关联元数据数 {{item.basicAtomNumberCount + item.basicDimensionNumberCount}}条</div>
                            <div class="omit">简介：{{item.remark}}</div>
                        </div>
                    </div>
                </el-col>
                <div class="noDataBox flex_1" v-if="!dataList.length">
                    <img src="@/assets/img/noData.png" class="noData">
                    <div>暂无数据</div>
                </div>
            </el-row>
            <el-table
                    :data="dataList"
                    size="small" height="100%"
                    class="table" ref="multipleTable" border v-show="showList == 1" @sort-change="sortChange">
                <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="basicDataName" label="名称" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <el-link class="fontSize12" type="primary" @click="searchTemplateData(row, 0)">
                            {{row.basicDataName}}
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="basicDataName" label="类型" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <span>元数据模板</span>
                    </template>
                </el-table-column>
                <el-table-column prop="basicDataAuthorityStrings" label="可修改权限" show-overflow-tooltip></el-table-column>
                <el-table-column prop="remark" label="简介" show-overflow-tooltip></el-table-column>
                <el-table-column prop="basicDimensionNumberCount" label="元数据维度条目数" width="120"
                                 sortable show-overflow-tooltip></el-table-column>
                <el-table-column prop="basicAtomNumberCount" label="元数据原子条目数" width="120"
                                 sortable show-overflow-tooltip></el-table-column>
                <el-table-column prop="createDate" sortable label="创建时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createByUserName" label="创建人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="updateDate" sortable label="最新修改时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="updateByUserName" label="最新修改人" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <!--维度、原子-->
        <div class="dataBox atomBox" v-if="navigation.length > 1" v-loading="loading">
            <el-row class="cardBox" :gutter="10" v-show="showList == 0">
                <el-col class="m_b1 pointer" :span="6" v-for="(item, index) in dataList" :key="index">
                    <div :class="['el-card is-always-shadow', item.basicType == 1 ? 'cursor_default':'']" @click="searchTemplateData(item)">
                        <div class="flex_b_c p_all1">
                            <div class="omit flex_1 name"><img src="@/assets/img/dimensionalityIcon.png" class="templateIcon" v-if="item.basicType == 0"><img src="@/assets/img/atomIcon.png" class="templateIcon" v-else>{{item.basicRename}}</div>
                        </div>
                        <div>
                            <div class="basicFor">
                                <el-tag size="mini" v-if="item.basicForAdd == 0">可新增</el-tag>
                                <el-tag size="mini" v-if="item.basicForEdit == 0">可编辑</el-tag>
                                <el-tag size="mini" v-if="item.basicForShow == 0">可查看</el-tag>
                            </div>
                            <div class="info">
                                <div class="omit">组件属性 <span v-if="item.basicRequired == 1">非</span>必填</div>
                                <div>组件类型 {{item.metadataBasicAssemblyName}}</div>
                            </div>
                        </div>
                        <div class="btnBox">
                            <el-link v-if="hasPermission('metadata:ruleList:rangeRule') && getBasicAssembly(item) == 'range'" type="primary"
                                     @click.stop="rangeRule(item)">值域规则
                            </el-link>
                            <el-link v-if="hasPermission('metadata:ruleList:dataRule') && getBasicAssembly(item) == 'data'" type="primary"
                                     @click.stop="dataRule(item)">数据规则
                            </el-link>
                            <el-link v-if="hasPermission('metadata:ruleList:hidingRule')" type="primary"
                                     @click.stop="hidingRule(item)">字段隐藏规则
                            </el-link>
                        </div>
                    </div>
                </el-col>
                <div class="noDataBox flex_1" v-if="!dataList.length">
                    <img src="@/assets/img/noData.png" class="noData">
                    <div>暂无数据</div>
                </div>
            </el-row>
            <el-table
                    :data="dataList"
                    size="small" height="100%"
                    class="table" ref="multipleTable" border v-show="showList == 1" @sort-change="sortChange">
                <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="basicRename" label="元数据名称" width="90" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <span v-if="row.basicType == 1">{{row.basicRename}}</span>
                        <el-link class="fontSize12" type="primary" v-else @click="searchTemplateData(row)">{{row.basicRename}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="basicName" label="关联元数据" width="90" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <span v-if="row.metadataBasicAssemblyName == '子模板' || row.metadataBasicAssemblyName == '子表单'">{{row.basicDataName}}</span>
                        <span v-else>{{row.basicName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="basicType" label="类型" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        {{$dictUtils.getDictLabel("basic_type", row.basicType ,'')}}
                    </template>
                </el-table-column>
                <el-table-column prop="metadataBasicAssemblyName" label="组件类型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="basicForShow" label="组件权限" width="180" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <el-tag size="mini" v-if="row.basicForAdd == 0">可新增</el-tag>
                        <el-tag size="mini" v-if="row.basicForEdit == 0">可编辑</el-tag>
                        <el-tag size="mini" v-if="row.basicForShow == 0">可查看</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="basicRequired" label="是否必填" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        {{$dictUtils.getDictLabel("public_state", row.basicRequired ,'')}}
                    </template>
                </el-table-column>
                <el-table-column prop="createDate" sortable label="关联时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createByUserName" label="关联人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="updateDate" sortable label="最新修改时间" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="updateByUserName" label="最新修改人" width="90" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" width="240" label="操作">
                    <template slot-scope="{row}">
                        <el-button v-if="hasPermission('metadata:ruleList:rangeRule') && getBasicAssembly(row) == 'range'" type="text" size="small"
                                   @click="rangeRule(row)">值域规则
                        </el-button>
                        <el-button v-if="hasPermission('metadata:ruleList:dataRule') && getBasicAssembly(row) == 'data'" type="text" size="small"
                                   @click="dataRule(row)">数据规则
                        </el-button>
                        <el-button v-if="hasPermission('metadata:ruleList:hidingRule')" type="text" size="small"
                                   @click="hidingRule(row)">字段隐显规则
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <pagination v-if="total" :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <RangeRule ref="rangeRule" @refreshDataList="refreshList()"></RangeRule>
        <DataRule ref="dataRule" @refreshDataList="refreshList()"></DataRule>
        <HidingRule ref="hidingRule" @refreshDataList="refreshList()"></HidingRule>
    </div>
</template>

<script>
    import RangeRule from './rangeRule'
    import DataRule from './dataRule'
    import HidingRule from './hidingRule'

    export default {
        components: {RangeRule, DataRule, HidingRule},
        data() {
            return {
                searchForm: {
                    basicName: '',
                    basicRename: '',
                    basicDataName: '',
                    basicDataId: '',
                    associationBasicId: '',
                    current: 1,
                    size: 20,
                    sortConfigs: [],
                },
                showList: '0',
                navigation: [
                    {
                        basicDataName: '元数据模板',
                        id: '',
                    }
                ],
                curNavigation: {},
                dataList: [],
                total: 0,
                loading: false,
                subTemplateFlag: false, // 是否在子模板内
            }
        },
        mounted() {
            this.refreshList(1)
            this.curNavigation = this.navigation[0]
        },
        methods: {
            // 获取数据列表 current查第几页数据
            refreshList(type) {
                if (type == 1) {
                    this.searchForm.current = 1
                }
                let api = '', method = 'post'
                // 模板列表
                this.searchForm.basicDataId = ''
                this.searchForm.associationBasicId = ''
                this.searchForm.associationBasicDataId = ''
                if (this.navigation.length == 1) {
                    api = this.api.metadata.selectMetadataBasicDataList
                } else {
                    // 模板详情列表  associationBasicDataId子模板、子表单; associationBasicId标题
                    api = this.api.metadata.selectByBasicDataId
                    if(this.navigation.length == 2) {
                        this.searchForm.basicDataId = this.curNavigation.id
                    } else {
                        this.searchForm.basicDataId = this.navigation[1].id
                        if(this.curNavigation.basicAssemblyId == '19' || this.curNavigation.basicAssemblyId == '20') {
                            this.searchForm.associationBasicDataId = this.curNavigation.associationBasicDataId
                        } else if(this.curNavigation.basicAssemblyId == '18') {
                            this.searchForm.associationBasicId = this.curNavigation.id
                        }
                    }
                }
                this.loading = true
                this.$axios(api, this.searchForm, method).then(data => {
                    if (data && data.status) {
                        this.dataList = data.data.records
                        if (this.dataList.length == 0 && this.searchForm.current > 1) {
                            this.searchForm.current--
                            this.refreshList()
                        }
                        this.total = parseInt(data.data.total)
                        this.loading = false
                    } else {
                        this.$message.error('查询失败')
                    }
                })
            },
            // 查询模板中的维度原子  type：0模板
            searchTemplateData(item, type) {
                if (item.basicType == 1) {
                    return
                }
                this.curNavigation = item
                this.navigation.push(item)
                if(type == 0) {
                    this.searchForm.basicDataId = item.id
                }
                this.filterSubTemplate()
            },
            // 点击导航栏
            selNavigation(item, index) {
                if (this.navigation.length == 1) {
                    return
                }
                this.curNavigation = item
                this.navigation = this.navigation.splice(0, index + 1)
                this.filterSubTemplate()
            },
            // 过滤是否有子模板
            filterSubTemplate() {
                this.dataListSelections = []
                this.$refs.searchForm.resetFields();
                let basicAssembly = this.navigation.filter(v => {return v.basicAssemblyId == '19' || v.basicAssemblyId == '20'})
                if(basicAssembly.length) {
                    this.subTemplateFlag = true
                } else {
                    this.subTemplateFlag = false
                }
                this.refreshList(1)
            },
            // 判断组件类型
            getBasicAssembly(item) {
                // 当组件类型为下拉单选、单选框组、下拉多选、多选框组、树状下拉时显示值域规则按钮
                let type = ['4', '5', '6', '7']
                // 当组件类型为单行文本、多行文本、日期组件、开关、数字、附件、图片、视频、音频时显示数据规则按钮
                let type2 = ['1', '2', '8', '9', '10', '12', '13', '14', '15', '16', '17']
                if(type.indexOf(item.basicAssemblyId) > -1) {
                    return 'range'
                }
                if(type2.indexOf(item.basicAssemblyId) > -1) {
                    return 'data'
                }
            },
            // 值域规则
            rangeRule(row) {
                this.$refs.rangeRule.init(row)
            },
            // 数据规则
            dataRule(row) {
                this.$refs.dataRule.init(row)
            },
            // 字段隐藏规则
            hidingRule(row) {
                this.$refs.hidingRule.init(row)
            },
            // 列表排序
            sortChange(column) {
                this.searchForm.sortConfigs = [
                    {
                        fieldName: column.prop,
                        sortOrder: column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : ''),
                    }
                ]
                this.refreshList()
            },
            // 重置
            reset() {
                this.$refs.searchForm.resetFields();
                this.refreshList(1)
            }
        },
    }
</script>

<style scoped lang="scss">
    .templateBox .el-card.templateCard {
        height: auto !important;
    }
</style>
